import React, { useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import { FieldArray, useFormikContext, Field } from "formik";
import {
  Autocomplete,
  Box,
  Button,
  IconButton,
  Typography,
} from "@mui/material";
import AddressFormFields from "../../../../common/components/address-component/address-component";
import InfoIcon from "../../../../assets/icons/info-icon.svg";
import { LocationMediaProps } from "../../service-management/service-management-props";
import { SelectInputComponent } from "../../../../common/components";
import { getProviderServiceLocations } from "../../../../api/provider-section/provider-service-management";
import { getPartnerId } from "./add-service-helper";

const LocationAndMedia: React.FC<LocationMediaProps> = ({ isReadOnly,
  locationOptions,
  setLocationOptions,
  selectedLocations,
  setSelectedLocations
}) => {
  const { values, setFieldValue, setFieldError, errors } =
    useFormikContext<any>();
  const { locations, images } = values.locationAndMedia;
  const [providerLocationOptions, setProviderLocationOptions] = React.useState<
    any[]
  >([]);
  // Store only the selected values (array of value strings)
  const [selectedLocationValues, setSelectedLocationValues] = React.useState<
    any[]
  >([]);
  // Store the selected full objects for preview and form value


  const fetchProviderServiceLocations = async () => {
    try {
      const providerId = getPartnerId(); // Replace with partner id
      const response = await getProviderServiceLocations(providerId);
      const locationsData = response?.data?.data?.data || [];
      // Transform to select options
      const options = locationsData.map((loc: any) => ({
        value: `${loc.city}, ${loc.state}, ${loc.zipcode}`,
        label: `${loc.city}, ${loc.state}, ${loc.zipcode}`,
        id: loc.id,
        city: loc.city,
        state: loc.state,
        zipcode: loc.zipcode,
      }));
      setProviderLocationOptions(options);
    } catch (error) {
      console.error("Error fetching provider service locations:", error);
    }
  };
  useEffect(() => {
    fetchProviderServiceLocations();
  }, []);
  return (
    <div className="location-media-wrapper">
      <h4 className="service-location-wrapper">Serviceable Locations</h4>
      <p className="sub-text">
        Add the locations where your services are available. All added
        locations will be shown below.
      </p>

      {/* Multi-select for locations */}
      <div className="form-field">
        <label>
          Locations<span className="required">*</span>
        </label>
        <SelectInputComponent
          fieldName="locationAndMedia.locations"
          options={providerLocationOptions}
          value={selectedLocations.map((loc: any) => loc.value)}
          onChange={(selected: any) => {
            // selected is array of value strings
            const selectedObjs = providerLocationOptions.filter((opt) =>
              selected?.includes(opt.value)
            );
            setSelectedLocations(selectedObjs);
            setFieldValue(
              "locationAndMedia.locations",
              selectedObjs.map(({ id, city, state, zipcode }) => ({
                id,
                city,
                state,
                zipcode,
              }))
            );
          }}
          multiple={true}
          notEditable={isReadOnly}
          placeholder="Select Location"
          isShowError={true}
          alwaysShowPlaceholder={true}
        />
      </div>

      {/* Preview selected locations */}
      <div className="added-locations">
        <h4>Selected Locations</h4>
        <p className="location-note">
          All your selected service locations will be listed here.
        </p>
        <Box
          className="location-values-preview-box"
          sx={{ border: "1px solid #ccc", borderRadius: 2, p: 2, mt: 1 }}
        >
          <div
            style={{
              display: "flex",
              fontWeight: "bold",
              borderBottom: "1px solid #eee",
              paddingBottom: 8,
              marginBottom: 8,
            }}
          >
            <span style={{ flex: 1 }}>Zipcode</span>
            <span style={{ flex: 2 }}>City</span>
            <span style={{ flex: 2 }}>State</span>
          </div>
          {selectedLocations && selectedLocations.length > 0 ? (
            selectedLocations.map((loc: any, idx: number) => (
              <div
                className="location-value-preview"
                key={loc.value || idx}
                style={{
                  display: "flex",
                  alignItems: "center",
                  borderBottom: "1px solid #f5f5f5",
                  padding: "6px 0",
                }}
              >
                <span
                  style={{ flex: 1 }}
                  className="location-preview-item-text"
                  title={loc?.zipcode}
                >
                  {loc?.zipcode}
                </span>
                <span
                  style={{ flex: 2 }}
                  className="location-preview-item-text"
                  title={loc?.city}
                >
                  {loc?.city}
                </span>
                <span
                  style={{ flex: 2 }}
                  className="location-preview-item-text"
                  title={loc?.state}
                >
                  {loc?.state}
                </span>
              </div>
            ))
          ) : (
            <Typography variant="body2" color="text.secondary" align="center">
              No locations selected yet
            </Typography>
          )}
        </Box>
      </div>
    </div>
  );
};

export default LocationAndMedia;
